// extracted by mini-css-extract-plugin
module.exports = {"mainColor":"#1e4e35","secondaryColor":"#f2f4ea","tepezzaGrey":"#7d7d7d"};